<template>
  <div class="modal-overlay" @click="onClickOverlay">
    <div :class="['modal !px-4', sizeClass]">
      <div class="modal-image-icon">
        <div class="flex justify-center items-center bg-[#CC0099] border-[3px] border-white rounded-full p-4 min-w-[80px] max-w-[80px]">
          <img
            src="/images/icons/ic-magnifying-glass-area-outline-white.svg"
            class=""
            alt="search"
          />
        </div>
      </div>
      <button
        v-if="props.showIconClose"
        class="modal-close"
        @click="props.onClose"
      >
        <img
          src="/images/icons/ic-x-mark-close-outline.svg"
          class="min-w-8 max-w-8 min-h-8 max-h-8"
          alt="close"
        />
      </button>

      <div v-if="props.showImage" class="modal-image">
        <img
          :src="
            props.imageSrc
              ? props.imageSrc
              : '/images/graphics/placeholder-image-landscape.svg'
          "
        />

        <div class="image-btn">
          <Button sizeSmall colorPrimary @click="props.onClose">{{
            props.btnTextCancel
          }}</Button>
        </div>
      </div>

      <div v-else>
        <div class="flex flex-col space-y-4 mb-10">
          <h3 class="text-[#1E293B] text-2xl font-bold">
            {{ props.textTitle }}
          </h3>
            <SelectChatbot
            v-if="!props.isScrollSearch"
              isNoPrefixIcon
              isIconOption
              :isClearable="false"
              :valueKey="modalData.searchValueSelected"
              :options="modalData.optionList"
              :onChange="props.onChangeSelect"
            />
          <SelectScrollLoad
          v-else
            isSearchIcon
            isTyping
            :isShowDropdownIcon="false"
            :label="props.textTitle"
            :isClearable="false"
            :valueKey="modalData.searchValueSelected"
            :options="formattedOptions"
            :hasMore="props.hasMore"
            :isLoading="props.isLoading"
            :onSearch="props.onSearch"
            :onLoadMore="props.onLoadMore"
            :onChange="props.onChangeSelect"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';

const componentName = 'ModalSearch';

// Props
const props = defineProps({
  size: {
    type: String,
    default: 'small',
    validator: (value) => ['small', 'medium', 'large'].includes(value),
  },
  showIconClose: {
    type: Boolean,
    default: true,
  },
  showIcon: {
    type: Boolean,
    default: true,
  },
  showButton2nd: {
    type: Boolean,
    default: true,
  },
  showTitle: {
    type: Boolean,
    default: true,
  },
  iconSwap: {
    type: Boolean,
    default: false,
  },
  slotSwap: {
    type: Boolean,
    default: false,
  },
  textTitle: {
    type: String,
    default: 'Title',
  },
  menuName: {
    type: String,
    default: '',
  },
  btnTextSuccess: {
    type: String,
    default: 'Save',
  },
  btnTextCancel: {
    type: String,
    default: 'Cancel',
  },
  onConfirm: {
    type: Function,
    default: function () {},
  },
  onClose: {
    type: Function,
    default: function () {},
  },
  showImage: {
    type: Boolean,
    default: false,
  },
  imageSrc: {
    type: String,
    default: '',
  },
  onChangeInput: {
    type: Function,
    default: function () {},
  },
  onClickOverlay: {
    type: Function,
    default: function () {},
  },
  optionList: {
    type: Array,
    default: [],
  },
  onChangeSelect: {
    type: Function,
    default: function () {},
  },
  onLoadMore: {
    type: Function,
    default: function () {},
  },
  onSearch: {
    type: Function,
    default: function () {},
  },
  hasMore: {
    type: Boolean,
    default: false,
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
  isScrollSearch: {
    type: Boolean,
    default: false,
  },
});

// Computed for size classes
const sizeClass = computed(() => {
  return {
    'modal-small': props.size === 'small',
    'modal-medium': props.size === 'medium',
    'modal-large': props.size === 'large',
  };
});

onMounted(() => {
  if(!props.isScrollSearch){
    getOptionList();
  }
});

const getOptionList = () => {
  modalData.optionList = props.optionList.map((e) => {
    return {
      text: e.name,
      value: e.id.toString(),
      icon: '/images/icons/ic-chat-bubble-outline-black.svg',
      data: e,
    };
  });
};

const formattedOptions = computed(() => {
  const formatted = props.optionList.map((e) => {
    // ถ้าเป็น group header ให้ส่งผ่านไปโดยตรง
    if (e.isGroup) {
      return e;
    }
    // ถ้าเป็น conversation ให้ format
    return {
      text: e.name,
      value: e.id.toString(),
      icon: '/images/icons/ic-chat-bubble-outline-black.svg',
      data: e,
    };
  });
  console.log('📋 ModalSearch formattedOptions:', { count: formatted.length, options: formatted });
  return formatted;
});

const modalData = reactive({
  optionList: [],
  searchValueSelected: undefined,
});



const onClickOverlay = (ev) => {
  if (ev.target !== ev.currentTarget) {
    return;
  }
  props.onClickOverlay();
};
</script>

<style lang="scss" scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal {
  background-color: #fff;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  text-align: center;
  position: relative;
  width: $semantic-dimension-container-width-sm;
  padding: 48px 0px 20px 0px;
  border-radius: 24px;
   
  position: relative;

  .modal-image-icon {
    position: absolute;
    top: -68px;
    left: 60%;
    transform: translate(-100%, 40%);
  }
}

.modal-close {
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
}
.slot-swap {
  margin-bottom: 20px;
}
.modal-image {
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.modal-image img {
  width: 100%;
  height: auto;
  margin-bottom: 10px;
}

.image-btn {
  margin-top: 10px;
}

.modal-small {
  width: $semantic-dimension-container-width-sm;
  padding: 48px 0px 20px 0px;
  gap: 0px;
  border-radius: $semantic-dimension-container-rounded-md;
   
}

.modal-medium {
  width: $semantic-dimension-container-width-md;
  padding: 80px 0px 40px 0px;
  border-radius: 24px;
   
}

.modal-large {
  width: $semantic-dimension-container-width-lg;
  padding: 80px 0px 40px 0px;
  gap: 0px;
  border-radius: $semantic-dimension-container-rounded-md;
   
}

.modal-footer {
  display: flex;
  justify-content: center;
  gap: 10px;
}

.second-button {
  background-color: #0056b3;
  color: white;
}
</style>
